import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as connectedReactRouter from 'connected-react-router'
import * as reducks from '../../../reducks'
import routes from '../../../config/routes'
import HeaderExternalLayout from '../../commons/HeaderExternalLayout/HeaderExternalLayout'
import RegisterPasswordForm from './RegisterPasswordForm'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import styles from './registerPassword.module.scss'

const RegisterPasswordContainer = () => {
  const dispatch = useDispatch()
  const handleSubmit = (data) =>
    dispatch(
      reducks.resources.users.actions.registerUserReceiveDataAndRegister(data)
    )

  useEffect(() => {
    const requirements = ['cnpj', 'email', 'phoneNumberCell']
    dispatch(
      reducks.resources.users.actions.registerUserRequirements(
        requirements,
        routes.registerPhone.path
      )
    )
  }, [])

  const { password, passwordConfirmation } = useSelector(
    (state) => state.usersReducer.content.registerUser.data
  )

  const initialValues = {
    password,
    passwordConfirmation
  }

  const back = () =>
    dispatch(connectedReactRouter.routerActions.push(routes.registerPhone.path))

  return (
    <ExternalLayout>
      <HeaderExternalLayout
        className={styles.container}
        title="Agora escolha uma senha"
        subtitle="A sua segurança é muito importante para você e seus clientes,
        certifique-se de escolher uma senha apropriada."
      />
      <RegisterPasswordForm
        handleSubmit={handleSubmit}
        initialValues={initialValues}
        back={back}
      />
    </ExternalLayout>
  )
}

export default RegisterPasswordContainer
